export default function Redo({ color = "#053137" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={{ flexShrink: 0 }}
    >
      <path
        d="M12.9325 3.63C14.4523 3.61392 15.9516 3.9806 17.2925 4.69623C18.6333 5.41186 19.7725 6.45344 20.605 7.725V4.74375H22V8.625C21.9971 8.96721 22 9.91875 22 9.91875C22 9.91875 21.0485 9.91581 20.7063 9.91875H16.8363V8.5125H19.4462C18.7441 7.4277 17.7783 6.53874 16.6391 5.92881C15.4999 5.31888 14.2246 5.00791 12.9325 5.025C11.01 4.95794 9.13897 5.65346 7.72709 6.95998C6.31521 8.26649 5.47695 10.0781 5.395 12C5.47695 13.9219 6.31521 15.7335 7.72709 17.04C9.13897 18.3465 11.01 19.0421 12.9325 18.975C14.855 19.0421 16.726 18.3465 18.1379 17.04C19.5498 15.7335 20.388 13.9219 20.47 12H21.865C21.7857 14.2928 20.8013 16.4609 19.1272 18.0296C17.4531 19.5983 15.2257 20.4398 12.9325 20.37C10.6393 20.4398 8.41194 19.5983 6.73783 18.0296C5.06372 16.4609 4.07928 14.2928 4 12C4.07928 9.70715 5.06372 7.5391 6.73783 5.97042C8.41194 4.40173 10.6393 3.56019 12.9325 3.63Z"
        fill={color}
      />
    </svg>
  );
}
